// extracted by mini-css-extract-plugin
export default {"userSubscriptionDetail":"styles_userSubscriptionDetail__-jenM"};